import { executePrintOnce, printRequestKey } from './pending-print-jobs';
import { PrintTransportSelector } from './print-transport.selector';
import { PrintRequest, PrintResult } from './printing.types';

export class PrintService {
  constructor(private readonly selector: PrintTransportSelector) {}

  print(request: PrintRequest): Promise<PrintResult> {
    const key = printRequestKey(request.documentType, request.documentId);
    return executePrintOnce(key, async () => {
      const transport = await this.selector.select(request.documentType);
      // Intencionalmente no hay catch/fallback: un error Desktop debe propagarse.
      return transport.print(request);
    });
  }
}
